import { OEButton, OEText, maxHeight } from '@openeducation/oe-it-components';
import { styled } from '@openeducation/oe-it-themes';
import React from 'react';
import { View } from 'react-native';

export interface ConnectionIssueModalProps {
  onReconnectPress?: () => void;
}

export const ConnectionIssueModal = ({
  onReconnectPress,
}: ConnectionIssueModalProps) => {
  return (
    <Container style={maxHeight(500)}>
      <TitleContainer>
        <OEText fontSize={20}>Unable to connect</OEText>
      </TitleContainer>
      <MessageContainer>
        <OEText fontSize={16}>
          Your connection has either dropped or isn't stable enough to maintain
          connection to our portal.
        </OEText>

        <View>
          <OEText fontSize={16}>
            - Connect directly to your router or modem with an ethernet cable.
          </OEText>
          <OEText fontSize={16}>- Disconnect from any VPN.</OEText>
          <OEText fontSize={16}>
            - If using a mobile hotspot, attempt a different network.
          </OEText>
        </View>

        <OEText fontSize={16}>
          Click "reconnect" below when you have resolved the issue. Log back
          into the portal and you can resume your shift!
        </OEText>

        <OEText fontType="medium" fontSize={16}>
          Need assistance? Contact the Support Team via Slack.
        </OEText>

        <OEButton onPress={onReconnectPress}>Reconnect</OEButton>
      </MessageContainer>
    </Container>
  );
};

const Container = styled.View`
  padding: 32px;
`;

const TitleContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }) => theme.color.border};
  padding-bottom: 16px;
`;

const MessageContainer = styled.View`
  gap: 16px;
  align-items: flex-start;
`;
